export default {"src":"/_next/static/media/samandehi.195bdf1d.svg","height":50,"width":88};